import Button from '../Button';
import PropTypes from 'prop-types';

import translating from '../../translate.json';
import './style.scss';

const ListHeader = ({ title, newItem, actions }) => {
  const renderAction = (item, key) => {
    const Icon = item.icon;
    return (
      <div
        key={key}
        className={`section-header-action-item ${item?.bottom ? 'bottom' : ''}`}
      >
        {Icon ? (
          <Icon onClick={item?.handleClickAction}></Icon>
        ) : (
          <Button txt={item.txt} handleClick={item.handleClick}></Button>
        )}
      </div>
    );
  };

  return (
    <div className="section-header">
      <div className="wrapper-section-title">
        <div className="section-title"> {title} </div>
        {newItem && newItem.handleClick ? (
          <Button
            txt={newItem.txt || translating.new}
            handleClick={newItem.handleClick}
          ></Button>
        ) : (
          <div></div>
        )}
      </div>
      <div className="section-actions">
        <div className="section-wrapper-actions">
          {actions?.map((action, index) => renderAction(action, index))}
        </div>
      </div>
    </div>
  );
};

export default ListHeader;

ListHeader.propTypes = {
  title: PropTypes.string,
  newItem: PropTypes.object,
  actions: PropTypes.array
};
